import React from 'react';
import FetchContact from './fetch-contact.component.js';
import { HashRouter, Route } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import ErrorBoundary from 'canopy-react-error-boundary';
import './contact-menu.js';

@ErrorBoundary({ featureName: 'contact record' })
@hot(module)
export default class Root extends React.Component {
  render() {
    return (
      <HashRouter basename="/">
        <div>
          <Route
            path="(.*)/client/:clientId"
            component={FetchContact}
            exact={false}
          />
          <Route
            path="(.*)/clients/:clientId"
            component={FetchContact}
            exact={false}
          />
        </div>
      </HashRouter>
    );
  }
}
